export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_47-f82e8773436d8f823b84958f19a62553.jpg";